import React from "react";

import { Button } from "@mui/material";

export const ModalSubmitButton = ({ onClick, type, disabled, children }) => (
  <Button
    onClick={onClick}
    color="success"
    variant="contained"
    sx={{
      height: 56,
      width: 56,
      boxShadow: "0px 0px 3px 2px #FFFFFF35",
      backgroundColor: "#33EB91C0",
      textTransform: "none",
      padding: "0px 45px",
      borderRadius: 2.5,
      fontFamily: '"proxima-nova", "sans-serif"',
    }}
    type={type}
    disabled={disabled}
    disableRipple
  >
    {children}
  </Button>
);
